<i18n src="@/lang/table.json"></i18n>
<i18n src="@/lang/actions.json"></i18n>
<i18n>
  {
    "en":{
      "t_actions":"Actions",
      "delete_integration": "Delete integration",
      "confirm_delete":"Are you sure to delete this?",
      "yes":"Yes",
      "no":"No",
      "deleted":"Deleted",
      "not_deleted":"Not deleted"
    },
    "ua":{
      "t_actions":"Дії",
      "delete_integration": "Видалити інтеграцію",
      "confirm_delete":"Вы уверены, что хотите удалить это?",
      "yes":"Так",
      "no":"Ні",
      "deleted":"Видалено",
      "not_deleted":"Не видалено"
    },
    "ru":{
      "t_actions":"Действия",
      "delete_integration": "Удалить интеграцию",
      "confirm_delete":"Дійсно видалити це?",
      "yes":"Да",
      "no":"Нет",
      "deleted":"Удалено",
      "not_deleted":"Не удалено"
    }
  }
</i18n>

<template>
  <el-main>
    <component
      :is="require('../_snippets/header_actions/header_actions').default"
    >
      <template slot="left-side">
        <el-input
          v-model="$store.state.shared_integrations.filter_string"
          class="filter-input-field"
          size="small"
          spa-action="find"
          clearable
          @change="addToFilterStrings"
        >
          <el-tag
            v-for="tag in $store.state.shared_integrations.filter_strings"
            :key="tag"
            slot="prepend"
            size="small"
            closable
            :disable-transitions="false"
            @close="deleteFromFilterStrings(tag)"
            >{{ tag }}
          </el-tag>
          <el-tooltip
            v-if="$store.state.shared_integrations.filter_strings.length"
            slot="append"
            class="item"
            effect="dark"
            :content="$t('actions.clear_all_filter_strings')"
            placement="bottom-end"
          >
            <el-button icon="el-icon-close" @click="clearAllFilters" />
          </el-tooltip>
        </el-input>
      </template>
    </component>
    <el-table
      :data="integrations"
      style="width: 100%"
      class="integrations-table"
    >
      <el-table-column width="100px">
        <el-image slot-scope="scope" :src="scope.row.image" fit="cover" />
      </el-table-column>
      <el-table-column sortable property="name" :label="$t('table.name')" />
      <el-table-column
        sortable
        property="widgetCode"
        :label="$t('table.widget-code')"
      />
      <el-table-column
        sortable
        property="amoDomain"
        :label="$t('table.amocrm')"
      />
      <el-table-column
        sortable
        header-align="center"
        align="center"
        property="OAuthCount"
        :label="$t('table.OAuth')"
      >
        <template slot-scope="{ row }">
          <i
            :class="{
              'el-icon-close error': row.OAuthCount === 0,
              'el-icon-check success': row.OAuthCount === 1,
              'el-icon-warning warning': row.OAuthCount > 1
            }"
            :style="{
              'font-weight': 'bold',
              color:
                row.OAuthCount === 0
                  ? 'red'
                  : row.OAuthCount === 1
                  ? 'green'
                  : 'orange'
            }"
          />
        </template>
      </el-table-column>
      <el-table-column
        sortable
        header-align="center"
        align="center"
        property="sharedCustomersServicesCount"
        :label="$t('table.service')"
      >
        <template slot-scope="{ row }">
          <i
            :class="{
              'el-icon-close error': row.sharedCustomersServicesCount === 0,
              'el-icon-check success': row.sharedCustomersServicesCount === 1,
              'el-icon-warning warning': row.sharedCustomersServicesCount > 1
            }"
            :style="{
              'font-weight': 'bold',
              color:
                row.sharedCustomersServicesCount === 0
                  ? 'red'
                  : row.sharedCustomersServicesCount === 1
                  ? 'green'
                  : 'orange'
            }"
          />
          <!--<template v-if="row.sharedCustomersServicesCount">
            <a
              style="cursor: pointer"
              v-text="
                $t('actions.open') +
                  (row.sharedCustomersServicesCount === 1
                    ? ''
                    : ' (' + row.sharedCustomersServicesCount + ')')
              "
              @click.prevent="() => handleOpenService(row)"
            />
          </template>-->
        </template>
      </el-table-column>
      <el-table-column
        header-align="right"
        align="right"
        property="sharedCustomersServicesCount"
        :label="$t('t_actions')"
      >
        <template slot-scope="{ row, $index }">
          <template v-if="row.sharedCustomersServicesCount">
            <el-button
              plain
              style="min-width: 150px"
              size="small"
              :type="
                row.sharedCustomersServicesCount === 1 ? 'primary' : 'success'
              "
              v-text="
                `${$t('actions.open')} ${$_.lowerCase($t('table.service'))}` +
                  (row.sharedCustomersServicesCount === 1
                    ? ''
                    : ' (' + row.sharedCustomersServicesCount + ')')
              "
              @click="() => handleOpenService(row)"
            />
          </template>
          <template v-else>
            <el-popconfirm
              :confirmButtonText="$t('yes')"
              :cancelButtonText="$t('no')"
              :title="$t('confirm_delete')"
              @onConfirm="() => handleDeleteIntegration(row, $index)"
            >
              <el-button
                slot="reference"
                plain
                style="min-width: 150px"
                size="small"
                type="danger"
                v-text="$t('delete_integration')"
              />
            </el-popconfirm>
          </template>
        </template>
      </el-table-column>
    </el-table>
  </el-main>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";

export default {
  name: "integrations-list",
  data: () => ({
    data: undefined
  }),
  async created() {
    this.setData(await this.getData());
  },
  methods: {
    ...mapActions({
      getData: "shared_integrations/getData",
      removeFromDataByUUID: "shared_integrations/removeFromDataByUUID"
    }),
    ...mapMutations({
      setData: "shared_integrations/setData",
      addToFilterStrings: "shared_integrations/addToFilterStrings",
      deleteFromFilterStrings: "shared_integrations/deleteFromFilterStrings",
      resetState: "shared_integrations/resetState",
      clearAllFilters: "shared_integrations/clearAllFilters"
    }),
    handleOpenService(row) {
      row._embedded.sharedCustomersServices.forEach(v => {
        let resolved = this.$router.resolve({
          name: "customers-services-v3.details",
          params: { service_id: v.uuid }
        });
        window.open(resolved.href, "_blank");
      });
    },
    async handleDeleteIntegration(row, index) {
      this.$log(...arguments);
      if (await row.handleDelete()) {
        // this.integrations.splice(index, 1);
        await this.removeFromDataByUUID(row.uuid);
        this.$notify.success({
          message: this.$t("deleted")
        });
        return;
      }
      this.$notify.error({
        message: this.$t("not_deleted")
      });
    }
  },
  computed: {
    ...mapGetters("shared_integrations", ["integrations"])
  }
};
</script>

<style lang="stylus">
.integrations-table
  & .cell
    overflow unset
</style>
<style scoped lang="stylus"></style>
